import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import './CheckBox.scss';

export default function CheckBox(props) {
  const { onChange, checked, name, label, style, boxColor } = props;

  const styleProps = style ? style : undefined
  const color = boxColor ? boxColor : 'black'

  return (
    <div id="ShopCheckBox">
      <FormControlLabel
        style={{ fontWeight: "bold", color: color }}
        control={< Checkbox checked={checked} onChange={onChange} name={name} style={{ color: color }} />}
        label={label}
      />
    </div>
  );
}

